module.exports = __webpack_public_path__ + "static/media/including.b1fdecff.png";